import React, { useState, useEffect, useRef, useMemo } from 'react';
import api from '../../services/api';
import { Link } from 'react-router-dom';
import DataGrid, {
  Column,
  Paging,
  Pager,
  FilterRow,
  Selection,
  SearchPanel,
  Toolbar,
  Item,
} from 'devextreme-react/data-grid';
import 'devextreme/dist/css/dx.material.blue.light.compact.css';
import { LoadPanel } from 'devextreme-react/load-panel';

const CompanyList = () => {
  const [companies, setCompanies] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const gridWrapperRef = useRef(null); // Ref for the grid wrapper
  const fetchCalled = useRef(false);

  useEffect(() => {
    if (fetchCalled.current) return;
    fetchCalled.current = true;

    setIsLoading(true);

    api.get('/Companies')
      .then((res) => {
        const transformedData = res.data.map((item) => ({
          ...item,
          CompanyID: item.id,
        }));
        setCompanies(transformedData);
      })
      .catch((err) => console.error('Error fetching applicants:', err))
      .finally(() => setIsLoading(false));
  }, []);

  const columns = useMemo(
    () => [
      { field: 'companyName', caption: 'Company Name' },
      { field: 'phoneNo', caption: 'Phone No.' },
      { field: 'mobileNo', caption: 'Mobile No.' },
      { field: 'eMail', caption: 'Email' },
      { field: 'country', caption: 'Country' },
      { field: 'city', caption: 'City' },
      { field: 'address', caption: 'Address' },
      { field: 'companyType', caption: 'CompanyType' },      
      { field: 'licenseDate', caption: 'License Date' },
      { field: 'registrationDate', caption: 'Reg Date' },
      { field: 'is_Active', caption: 'Active' },
    ],
    []
  );

  return (
    <div className="w-100 h-100 bg-white rounded p-1" ref={gridWrapperRef}>
    {/* Add ref to the wrapper */}
      <LoadPanel
        shadingColor="rgba(0,0,0,0.4)"
        position={{ of: '.dx-datagrid' }}
        visible={isLoading}
        showIndicator={true}
        shading={false}
        showPane={true}
      />

      <DataGrid
        name = "_dxGrid"
        dataSource={companies}
        showBorders
        rowAlternationEnabled
        allowColumnResizing
        columnAutoWidth       
        wordWrapEnabled 
        focusedRowEnabled
        showColumnLines
        keyExpr="companyID"
        height="100%"
        width="100%"
      >
        <Toolbar>
          <Item location="before">
            <div className="d-flex align-items-center es-label-title">
              <strong>COMPANIES</strong>               
            </div>
          </Item>   
          <Item name="searchPanel" />          
        </Toolbar>

        <SearchPanel visible highlightCaseSensitive />
        <FilterRow visible />
        <Selection mode="multiple" />
        <Paging defaultPageSize={15} />
        <Pager showPageSizeSelector allowedPageSizes={[15, 25, 50]} showInfo />

        <Column
          caption="..."
          width={50}
          cellRender={(data) => <Link to={`/companies/edit/${data.data.companyID}`}>Edit...</Link>}
        />

        {columns.map(({ field, caption }) => (
          <Column key={field} dataField={field} caption={caption} allowFiltering 
          customizeText={field === 'licenseDate' || field === 'registrationDate'
            ? (cellInfo) => {
                if (!cellInfo.value) return '';
                const date = new Date(cellInfo.value);
                return isNaN(date.getTime()) ? cellInfo.value : date.toLocaleDateString('en-GB');
              }
            : undefined}
          />
        ))}

      </DataGrid>
    </div>
  );
};

export default CompanyList;